import { render, staticRenderFns } from "./product-details-pricing-profiles.vue?vue&type=template&id=4e504e06&scoped=true&"
import script from "./product-details-pricing-profiles.vue?vue&type=script&lang=js&"
export * from "./product-details-pricing-profiles.vue?vue&type=script&lang=js&"
import style0 from "./product-details-pricing-profiles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product-details-pricing-profiles.vue?vue&type=style&index=1&id=4e504e06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e504e06",
  null
  
)

export default component.exports